import { Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import Message from "../../components/message";
import { MessageSections } from "../../components/message/message";
import { UserAddresses } from "./user-addresses/user-addresses";
import { PersonalInfo } from "./personal-info/personal-info";
import { UserNotifications } from "./user-notifications/user-notifications";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import Recipients from "./recipients";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { SettingsContainer, SettingsTabContainer, UserTabs } from "./styled";
import {
    getCities,
    getCountries,
    getProvinces,
    getRecipientDocumentTypes,
    getRegions
} from "../../../redux/slices/static-data.slice";
import { ActionBar } from "../../components/action-bar/action-bar";
import { BarekamIcon, IconVariants } from "../../components/icon/barekam-icon";
import { OutletContext } from "../../../router/router";

enum TabType {
    PERSONAL_INFO,
    MY_ADDRESSES,
    MY_RECIPIENTS,
    NOTIFICATIONS,
    // MY_UPLOADS /*temporary disabled
}

const userTabs = [
    {
        type: TabType.PERSONAL_INFO,
        messageKey: 'personal_info',
        icon: IconVariants.user,
        component: <PersonalInfo />,
        availableForSystemUsers: true,
        availableForUnvalidatedUsers: true
    },
    {
        type: TabType.MY_ADDRESSES,
        messageKey: 'my_addresses',
        icon: IconVariants.home,
        component: <UserAddresses />
    },
    {
        type: TabType.MY_RECIPIENTS,
        messageKey: 'my_recipients',
        icon: IconVariants.users,
        component: <Recipients />,
        availableForUnvalidatedUsers: true
    },
    {
        type: TabType.NOTIFICATIONS,
        messageKey: 'notifications',
        icon: IconVariants.notifications,
        component: <UserNotifications />
    },
    // {type: TabType.MY_UPLOADS, messageKey: 'my_uploads', component: <UserUploads/>}, /*temporary disabled
]

export const Settings = ({ hasValidatedRecipient }: { hasValidatedRecipient: boolean }) => {
    const [isReady, setIsReady] = useState(false);
    const [tab, setTab] = useState(userTabs[0]);
    const { matchesPhone } = useAppSelector(state => state.deviceReducer);

    const outletContext = useOutletContext<OutletContext>();

    const navigate = useNavigate();
    const location = useLocation();
    const urlTabIndex = +location.hash.replaceAll('#', '');

    const dispatch = useAppDispatch();

    useEffect(() => {
        Promise.allSettled([
            dispatch(getCountries()),
            dispatch(getProvinces()),
            dispatch(getCities()),
            dispatch(getRegions()),
            dispatch(getRecipientDocumentTypes()),
        ]).then(() => setIsReady(true))
    }, [])

    useEffect(() => {
        if (urlTabIndex < userTabs.length) {
            setTab(userTabs[urlTabIndex])
        }
    }, [urlTabIndex])

    const handleChange = (selectedType: { type: TabType; messageKey: string; component: JSX.Element; icon: IconVariants }) => {
        setTab(selectedType);
        navigate(location.pathname + '#' + selectedType.type, { replace: true });
    };

    function isTabVisible(tabInfo: any) {
        if (outletContext.isAdmin || outletContext.isWarehouseWorker || outletContext.isPdr) {
            return tabInfo.availableForSystemUsers;
        } else {
            return tabInfo.type === 0
                || hasValidatedRecipient
                || (!hasValidatedRecipient && tabInfo.availableForUnvalidatedUsers);
        }
    }

    if (isReady) {
        return (
            <SettingsContainer>
                <ActionBar headerText={<Message messageKey={'my_account'} sectionId={MessageSections.USER} />} />

                <UserTabs value={tab.type}
                    variant={matchesPhone ? 'fullWidth' : "scrollable"}
                    scrollButtons={true}
                >
                    {
                        userTabs.map(tabInfo => {
                            if (isTabVisible(tabInfo)) {
                                return (
                                    <Tab value={tabInfo.type}
                                        key={tabInfo.messageKey}
                                        label={matchesPhone
                                            ? <BarekamIcon variant={tabInfo.icon} />
                                            : <Message messageKey={tabInfo.messageKey} sectionId={MessageSections.USER} />}
                                        onClick={() => handleChange(tabInfo)}
                                    />
                                )
                            } else {
                                return ''
                            }
                        })
                    }
                </UserTabs>

                <SettingsTabContainer>
                    {tab.component}
                </SettingsTabContainer>
            </SettingsContainer>
        );
    } else {
        return <></>
    }
}
